// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"5fd12c9d","827":"fba8d06e"}[chunkId] + ".chunk.js";
};